import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { notification } from 'antd';
import { AuditOutlined } from '@ant-design/icons';

import { RibbonButton, dialogFunction } from 'common/components';

import Messages from 'i18n/messages/home';
import messagesProduct from 'i18n/messages/product';
import userSelectors from '@redux/user/selectors';

import { executeMatchingApl } from 'services/aplDetail';
import { makeSelectAplDetail } from 'pages/product-apl-detail/controllers/selectors';
import {
  toggleReloadGrid,
  getAplDetail,
} from 'pages/product-apl-detail/controllers/actions';

const ExecuteMatching = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const aplDetail = useSelector(makeSelectAplDetail());
  const memberID = useSelector(userSelectors.makeSelectUserMemberId());

  const refetchAplDetail = () => {
    dispatch(getAplDetail({ aplId: aplDetail?.aplId }));
  };

  //* If visibility = Company (Member).
  //* Only users who belong to the company owner could execute matching.
  //* If visibility = Personal.
  //* oNLY users who created the APL could execute matching.
  const isDisabledExecuteMatching = (apl, currentMemberId) => {
    if (apl?.visibility === 'Personal') {
      return !apl?.isOwner;
    }
    if (apl?.visibility === 'Company') {
      return !(apl?.companyId === currentMemberId);
    }
    return true;
  };

  const handleExecuteMatching = () => {
    dialogFunction({
      type: 'warn',
      content: intl.formatMessage(messagesProduct.confirmExecuteMatchingApl),
      okText: 'OK',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          const response = await executeMatchingApl({
            aplId: aplDetail?.aplId,
          });

          if (response?.isSuccess) {
            notification.success({
              message:
                response?.message ??
                intl.formatMessage(messagesProduct.executeMatchingAplSuccess),
            });
            dispatch(toggleReloadGrid(true));
            refetchAplDetail();
          } else {
            notification.error({
              message: response?.message,
            });
          }
        } catch (error) {
          throw new Error(error);
        } finally {
          setTimeout(() => {
            dispatch(toggleReloadGrid(false));
          });
        }
      },
    });
  };

  return (
    <RibbonButton
      icon={<AuditOutlined style={{ height: 26 }} />}
      label={Messages.executeMatchingApl}
      onClick={handleExecuteMatching}
      disabled={isDisabledExecuteMatching(aplDetail, memberID)}
    />
  );
};

export default ExecuteMatching;
